module.exports = __webpack_public_path__ + "static/media/recipiente3.11bd1924.jpg";